import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-5816ab15"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-gray-500 font-semibold" }


export default /*#__PURE__*/_defineComponent({
  __name: 'EmptyTag',
  props: {
		asset: {
			type: String,
			default: "/media/images/no-data-img.svg",
		},
		style: {
			type: String,
			default: "",
		},
		styleAsset: {
			type: String,
			default: "",
		},
		height: {
			type: String,
			default: "",
		},
	},
  setup(__props) {

	

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([__props.style, { 'bg-no-repeat flex flex-col justify-center w-full items-center animate-pulse': true }]),
    style: _normalizeStyle({ height: __props.height })
  }, [
    _createElementVNode("span", {
      style: _normalizeStyle({
				backgroundImage: 'url(' + __props.asset + ')',
				backgroundSize: 'contain',
				backgroundPosition: 'center',
			}),
      class: _normalizeClass([
				__props.styleAsset,
				{
					'w-full h-28 bg-no-repeat mb-6': true,
				},
			])
    }, null, 6),
    _createElementVNode("p", _hoisted_1, [
      _renderSlot(_ctx.$slots, "default", {}, () => [
        _createTextVNode("Oups, Aucune donnée pour le moment...")
      ])
    ])
  ], 6))
}
}

})